import * as React from 'react';

import { IconButton, IconButtonProps } from 'omakase';
import { IconCrossLarge } from '@tock/icons';
import { Theme } from '@emotion/react';
import { tagBase, tagContent, tagVariant } from './tagCssDefs';

export type IconButtonPropsOverride = Partial<Pick<IconButtonProps, 'aria-label'>> &
  Pick<IconButtonProps, 'disabled'>;

export type TagVariant = 'basic' | 'highContrast';

export interface TagCoreProps {
  /**
   * The props to be passed
   */
  IconButtonProps?: IconButtonPropsOverride;
  /**
   * The click event for the component's button
   */
  onDelete?(): void;
  /**
   * The variant (color style) for the tag
   */
  variant: TagVariant;
  className?: string;
}

export type TagProps = TagCoreProps;

const Tag: React.FunctionComponent<TagProps> = ({
  IconButtonProps = {},
  children,
  onDelete,
  variant,
  ...rest
}) => {
  const iconButtonProps: IconButtonProps = {
    'aria-label': `Remove ${children} tag`,
    ...IconButtonProps,
    onClick: onDelete,
    size: 'xsmall',
    variant: variant === 'highContrast' ? 'highContrast' : 'basic',
  };

  return (
    <span
      css={(theme: Theme) => [tagBase(theme, !!onDelete), tagVariant(theme, variant)]}
      {...rest}
    >
      <span css={tagContent}>{children}</span>
      {onDelete && (
        <IconButton {...iconButtonProps}>
          <IconCrossLarge />
        </IconButton>
      )}
    </span>
  );
};

export default Tag;
